import { SetupDataStore, useProviderConfig } from '@servicetitan/financing-workflow-shared';
import { FinancedAmountStore } from '../financing-information/financedAmountStore';
import { PlansList } from '../plans/PlansList';
import { useLoadPrequalsPlans } from './hooks';
import { PrequalsStore } from '../prequals-financing-information/prequalsStore';
import { useEffect, useRef } from 'react';
import { LoadingScreen } from '@servicetitan/financing-utils-shared';
import { Calculation } from '@servicetitan/financing-api-client';

interface ContainerProps {
    onPlanSelected?: (plan: Calculation) => void;
}

export const Container = (props: ContainerProps) => {
    const { saleAmount } = FinancedAmountStore.useStore();
    const { setupData } = SetupDataStore.useStore();
    const { isAmountConfirmed } = PrequalsStore.useStore();
    const { planSelectionInstructions } = useProviderConfig();

    const { onPlanSelected } = props;
    const hasLoadedPlansRef = useRef(false);

    const isGoodLeap = setupData?.provider?.toLowerCase() === 'goodleap';
    const hasAmount = saleAmount > 0;
    const hasState = !!setupData?.state;
    const prequalId = setupData?.prequalificationId;

    // Check if query should be enabled (same conditions as in the hook)
    const isQueryEnabled = !!prequalId && saleAmount > 0 && isAmountConfirmed;

    // Always call hook with same number of arguments to follow Rules of Hooks
    // state is optional, so we can pass undefined when not available
    const {
        data: plans,
        isSuccess,
        isLoading,
        isFetching,
    } = useLoadPrequalsPlans(saleAmount, setupData?.state);

    // Track if plans have been successfully loaded at least once (even if empty)
    // This ensures PlansList stays visible after first load, even if user changes values
    useEffect(() => {
        if (isSuccess && plans !== undefined) {
            hasLoadedPlansRef.current = true;
        }
    }, [isSuccess, plans]);

    if (isQueryEnabled && (isLoading || isFetching)) {
        return <LoadingScreen message="Loading available plans..." />;
    }

    // Update the early return condition to also check state for GoodLeap
    if (
        !hasLoadedPlansRef.current &&
        (!hasAmount || (isGoodLeap && (!isAmountConfirmed || !hasState)))
    ) {
        return null;
    }

    return (
        <PlansList
            plans={plans ?? []}
            onPlanSelected={onPlanSelected}
            disableSelection={!isAmountConfirmed}
            instructions={planSelectionInstructions}
        />
    );
};
